<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { refererLogin } from "@/api/api";
import { GetQueryString } from "@/utils/utils";

export default {
  mounted() {
    this.$store.dispatch("init", res => {
      if (this.$route.name === "login") {
        if (res) {
          this.$router.replace({ name: "home" });
        }
      }
    });
  },
  methods: {}
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.anchorBL {
  display: none;
}
.el-checkbox {
  color: white !important;
}

.base-map {
  background-color: #091933 !important;
}

.el-input.is-disabled .el-input__inner,
.el-input__inner {
  border: 1px solid #314269 !important;
  border-radius: 8px !important;
  background-color: #091939 !important;
  color: white !important;
}

.el-date-editor .el-range-input,
.el-date-editor .el-range-separator,
.el-picker-panel,
.el-date-table th {
  color: white !important;
}

.el-date-table td.in-range div,
.el-date-table td.in-range div:hover,
.el-date-table.is-week-mode .el-date-table__row.current div,
.el-date-table.is-week-mode .el-date-table__row:hover div {
  background-color: #035c9e !important;
}
button,
input,
select,
textarea {
  background-color: transparent;
  border-style: none;
  color: inherit;
}

.el-picker-panel {
  background: #091228 !important;
  border: 1px solid #314269 !important;
}

.el-date-range-picker__content.is-left {
  border-right: 1px solid #314269 !important;
}

.el-picker-panel__footer {
  border-top: 1px solid #314269 !important;
  background-color: #091228 !important;
}

.el-date-range-picker__time-header,
.el-date-table th {
  border-bottom: 1px solid #314269 !important;
}

.BMapLib_SearchInfoWindow {
  position: absolute;
  border: 0px solid transparent;
  background-color: #020c1c;
  border: 2px solid #3df2fd;
  // border-image: url(../assets/img/2.png) 0 fill stretch;
  color: white;
  .BMapLib_trans {
    position: absolute;
  }
  .BMapLib_bubble_tools {
    padding-right: 5px;
    position: absolute;
    top: 1%;
    right: 10px;
    height: 30px;
    width: 64px;
    z-index: 10000;
    div {
      float: right;
      height: 30px;
      width: 22px;
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0);
      cursor: pointer;
      overflow: hidden;
    }
    .BMapLib_sendToPhone {
      display: none;
    }
  }
  .BMapLib_bubble_title {
    height: 0;
    color: white;
    background-color: rgba(0, 0, 0, 0);
    font-size: 22px;
    text-align: center;
    line-height: 40px;
    font-weight: 700;
  }
  .BMapLib_bubble_top {
    height: 15px;
  }
}
.el-dialog__header {
  padding: 0 !important;
}

.el-cascader__dropdown {
  font-size: 1.604vh !important;
}
.el-input--suffix .el-input__inner,
.el-range-editor--small.el-input__inner {
  height: 3.42vh !important;
  line-height: 3.42vh !important;
  padding-right: 1.56vw !important;
}

.el-range-editor--small .el-range__close-icon,
.el-range-editor--small .el-range__icon {
  line-height: 1.62vh !important;
}

.el-range-editor--small .el-range-separator {
  line-height: 2.56vh !important;
}

.el-scrollbar__wrap {
  max-height: 21.8vh !important;
}

.detail-chart {
  height: 300px;
}
.dialog-title {
  color: white;
}
.detail-time {
  color: #bbbbbb;
  margin-bottom: 5px;
}

.el-dialog__wrapper {
  left: 10% !important;
}

.color-bar-slider {
  &:hover {
    .ant-slider-handle:not(.ant-tooltip-open) {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 10px solid white;
      border-radius: 0;
    }
  }
  .ant-slider-rail {
    display: none;
  }
  .ant-slider-step {
    display: none;
  }
  .ant-slider-track {
    display: none;
  }
  .ant-slider-handle {
    border-bottom: none !important;
    width: 0 !important;
    height: 0 !important;
    border-left: 5px solid transparent !important;
    border-right: 5px solid transparent !important;
    border-top: 10px solid white !important;
    border-radius: 0 !important;
    background-color: #fff0 !important;
  }
}

.ant-slider-vertical {
  margin: 6px 18px !important;
  height: 82% !important;
}
.el-picker-panel__icon-btn {
  color: white !important;
}
</style>
